import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import {map} from 'rxjs/operators';
import {QueryParamsService} from '../../core/services/query-params.service';


@Injectable()
export class FileRestService {

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  getFile(fileUrl: string, options?: {rejectPending?: boolean; headers?: HttpHeaders}): Observable<File> {
    if (options?.rejectPending) {
      return this.http.get(fileUrl, {responseType: 'blob', observe: 'response', headers: options.headers}).pipe(map(response => {
        if (response.status === 202) {
          throw new HttpErrorResponse({status: 202, error: {code: 'DOCUMENT_NOT_READY'}});
        }
        if (!response.body?.size) {
          throw new HttpErrorResponse({status: 502, error: {code: 'DOCUMENT_EMPTY_FILE'}});
        }
        return new File([response.body], fileUrl.split('/').pop() || 'file', {type: response.body.type, lastModified: Date.now()});
      }));
    }
    return from(this.http.get(fileUrl, { responseType: 'blob' }).toPromise()
      .then((blob) => {
        if (!blob) {
          throw new Error('Empty file response');
        }
        return blob;
      })
      .then((blob) => {
        const imgParts = fileUrl.split('/').pop() || 'file';
        return new File([blob], imgParts, { type: blob.type, lastModified: Date.now() });
      })
      .catch((error) => {
        console.error("Error fetching file:", error);
        throw new Error("Failed to fetch file due to CORS issue or network error");
      }));
  }
}
